import { isEmpty, isNil } from "lodash";
import { mixed, object, string } from "yup";

import { translate } from "utils/translations/translate";

const MAX_DESCRIPTION_LENGTH = 200;
const MIN_DESCRIPTION_LENGTH = 1;
const MAX_FILE_SIZE = 20;
const validationSchema = object().shape({
  description: string()
    .required(translate.t("validations.required"))
    .min(
      MIN_DESCRIPTION_LENGTH,
      translate.t("validations.minLength", { count: MIN_DESCRIPTION_LENGTH }),
    )
    .max(
      MAX_DESCRIPTION_LENGTH,
      translate.t("validations.maxLength", { count: MAX_DESCRIPTION_LENGTH }),
    )
    .isValidTextBeginning()
    .isValidTextField(),
  file: mixed()
    .isValidFunction((value: unknown): boolean => {
      if (value === undefined || isEmpty(value)) {
        return false;
      }

      return (value as FileList).length !== 0 || !isNil(value as FileList);
    }, translate.t("groupAlerts.noFileSelected"))
    .isValidFileSize(translate.t("groupAlerts.fileSize"), MAX_FILE_SIZE)
    .isValidFileType(["xlsx"], translate.t("groupAlerts.fileTypeXlsx")),
});

export { validationSchema, MAX_DESCRIPTION_LENGTH };
